import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { IconTrash } from '@tabler/icons-react';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import axios from "../../../library/axios";
import { MySwal } from '../../../library/swal';

const DocumentScoresComp = (props) => {
    // console.log(props)
    const [elementPenilaian, setElementPenilaian] = useState([]);
    const [role, setRole] = useState("");

    const fetchOneUser = async () => {
        try {
            const options = {
                url: `/users/detailUser`,
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
        } catch (err) {
            console.log(err.message);
        }
    };

    const fetchData = async () => {
        try {
            const options = {
                url: `/doc-scores/document/${props?.documentId}`,
                method: "GET",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
                },
            };
            const { data } = await axios(options);
            // console.log(data)
            // return false
            setElementPenilaian(data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData();
        fetchOneUser();
    }, []);

    const columns = [
        {
            name: 'Elemen Penilaian',
            selector: (row) => `${row?.skor?.variables_accreditation?.elements_accreditation?.Nomor} ${row?.skor?.variables_accreditation?.Abjad}`,
        },
        {
            name: 'Aksi',
            cell: (row) => (
                <>
                    {role === "Kelompok Kerja" && props?.isIdBabExist && (
                        <button
                            className="btn btn-outline-warning btn-sm"
                            type="button"
                            title="Hapus"
                            onClick={() => handleDelete(row.id)}
                        >
                            <IconTrash stroke={2} />
                        </button>
                    )}
                </>
            ),
        },
    ];

    const handleDelete = (id) => {
        MySwal.fire({
            title: "Apakah anda yakin ?",
            text: "Data akan dihapus permanen",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#26D07C",
            cancelButtonColor: "#191919",
            confirmButtonText: "Ya, Lakukan!",
            cancelButtonText: "Batal"
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    url: `/doc-scores/${id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
                })
                    .then(res => {
                        // console.log(res)
                        // return false
                        if (res.status === 200) {
                            MySwal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Berhasil menghapus data!'
                            })

                            fetchData()
                        }
                    })
                    .catch(err => {
                        if (err !== "") {
                            console.log(err?.response?.data?.message)
                            MySwal.fire({
                                icon: 'error',
                                title: 'Oops, Error!',
                                text: `${err?.response?.data?.message}`
                            })
                        }
                    })
            }
        });
    }

    // console.log(elementPenilaian)

    return (
        <div>
            <DataTable
                columns={columns}
                data={elementPenilaian}
                pagination
                fixedHeader
                highlightOnHover
            />
        </div>
    )
}

export default DocumentScoresComp
